import React from 'react'

export const SystemAvatar = () => (
  <div
    className='flex justify-center items-center rounded-full border 
        border-white text-xs text-white bg-black w-[30px] h-[30px]'
  >
    <p className='font-bold text-[0.65rem]'>MAX</p>
  </div>
)
